import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const updatePasswordSchema = z.object({
  currentPassword: z.string().min(1), // Just check it's not empty
  newPassword: z.string().min(6, "Password must be at least 6 characters long"),
});

export class UpdatePasswordDto extends createZodDto(updatePasswordSchema) {}
